import React, { useEffect, useState } from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { SelectComponent } from 'component/Select';
import { getOrganizationsRestricted } from 'api/OrganizationsApi';
import { ORGANIZATION_OPTIONS } from 'consts/Organizations';

export const ReportingOrganization = (props) => {
  const { general } = props.formData.info;
  const [options, setOptions] = useState(ORGANIZATION_OPTIONS);

  useEffect(() => {
    getOrganizationsRestricted()
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        if (data.length) {
          setOptions(data.map((org) => ({ value: org.name, label: org.name })));
        }
      })
      .catch((error) => {
        console.error('Error fetching organizations:', error);
      });
  }, []);

  const handleInput = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        general: {
          ...prevFormData.info.general,
          reporter_organization: value,
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>{props.formType === 'ha' ? '1.5' : '1.3'}</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Організація, що звітує"
      titleEN="Reporting organization"
      children={(
        <SelectComponent
          options={options}
          value={options.find(
            (option) => option.value === general.reporter_organization
          ) || options[0]}
          handleSelect={handleInput}
        />
      )}
    />
  );
};
